// This file is auto-generated by @hey-api/openapi-ts
import type { Client, Options as ClientOptions, TDataShape } from './client';
import { client as _heyApiClient } from './client.gen';
import type {
  AuthenticateData,
  AuthenticateErrors,
  ClearAllMentionsData,
  ClearAllMentionsErrors,
  ClearAllMentionsResponses,
  ClearChatMessageData,
  ClearChatMessageErrors,
  ClearChatMessageResponses,
  CollectionSearchData,
  CollectionSearchErrors,
  CollectionSearchResponses,
  CopyManyItemsData,
  CopyManyItemsErrors,
  CopyManyItemsResponses,
  CreateAppActionData,
  CreateAppActionErrors,
  CreateAppActionResponses,
  CreateAppData,
  CreateAppDataData,
  CreateAppDataErrors,
  CreateAppDataFileData,
  CreateAppDataFileErrors,
  CreateAppDataFileResponses,
  CreateAppDataResponses,
  CreateAppErrors,
  CreateAppResponses,
  CreateAppSettingData,
  CreateAppSettingErrors,
  CreateAppSettingFileData,
  CreateAppSettingFileErrors,
  CreateAppSettingFileResponses,
  CreateAppSettingResponses,
  CreateBookmarkData,
  CreateBookmarkErrors,
  CreateBookmarkResponses,
  CreateChatMessageData,
  CreateChatMessageErrors,
  CreateChatMessageResponses,
  CreateChatbotCompletionPromptData,
  CreateChatbotCompletionPromptErrors,
  CreateChatbotCompletionPromptResponses,
  CreateDocumentData,
  CreateDocumentErrors,
  CreateDocumentResponses,
  CreateEtherpadData,
  CreateEtherpadErrors,
  CreateEtherpadResponses,
  CreateFolderData,
  CreateFolderErrors,
  CreateFolderResponses,
  CreateFolderWithThumbnailData,
  CreateFolderWithThumbnailErrors,
  CreateFolderWithThumbnailResponses,
  CreateInvitationData,
  CreateInvitationErrors,
  CreateInvitationResponses,
  CreateItemData,
  CreateItemErrors,
  CreateItemFlagData,
  CreateItemFlagErrors,
  CreateItemFlagResponses,
  CreateItemLikeData,
  CreateItemLikeErrors,
  CreateItemLikeResponses,
  CreateItemMembershipData,
  CreateItemMembershipErrors,
  CreateItemMembershipResponses,
  CreateItemResponses,
  CreateItemWithThumbnailData,
  CreateItemWithThumbnailErrors,
  CreateItemWithThumbnailResponses,
  CreateLinkData,
  CreateLinkErrors,
  CreateLinkResponses,
  CreateMembershipRequestData,
  CreateMembershipRequestResponses,
  CreateOwnProfileData,
  CreateOwnProfileErrors,
  CreateOwnProfileResponses,
  CreatePageData,
  CreatePageErrors,
  CreatePageResponses,
  CreatePasswordData,
  CreatePasswordErrors,
  CreatePasswordResponses,
  CreateShortLinkData,
  CreateShortLinkErrors,
  CreateShortLinkResponses,
  CreateShortcutData,
  CreateShortcutErrors,
  CreateShortcutResponses,
  CreateTagForItemData,
  CreateTagForItemErrors,
  CreateTagForItemResponses,
  CreateVisibilityData,
  CreateVisibilityErrors,
  CreateVisibilityResponses,
  DeleteAliasData,
  DeleteAliasErrors,
  DeleteAliasResponses,
  DeleteAppDataData,
  DeleteAppDataErrors,
  DeleteAppDataResponses,
  DeleteAppSettingData,
  DeleteAppSettingErrors,
  DeleteAppSettingResponses,
  DeleteBookmarkData,
  DeleteBookmarkErrors,
  DeleteBookmarkResponses,
  DeleteChatMessageData,
  DeleteChatMessageErrors,
  DeleteChatMessageResponses,
  DeleteCurrentAccountData,
  DeleteCurrentAccountErrors,
  DeleteCurrentAccountResponses,
  DeleteGeolocationData,
  DeleteGeolocationErrors,
  DeleteGeolocationResponses,
  DeleteInvitationData,
  DeleteInvitationErrors,
  DeleteInvitationResponses,
  DeleteItemLikeData,
  DeleteItemLikeErrors,
  DeleteItemLikeResponses,
  DeleteItemLoginSchemaData,
  DeleteItemLoginSchemaErrors,
  DeleteItemLoginSchemaResponses,
  DeleteItemMembershipData,
  DeleteItemMembershipErrors,
  DeleteItemMembershipResponses,
  DeleteItemsByIdThumbnailsData,
  DeleteItemsByIdThumbnailsResponses,
  DeleteManyItemsData,
  DeleteManyItemsErrors,
  DeleteManyItemsResponses,
  DeleteMembersMembersByIdDeleteData,
  DeleteMembersMembersByIdDeleteResponses,
  DeleteMembershipRequestData,
  DeleteMembershipRequestResponses,
  DeleteMentionData,
  DeleteMentionErrors,
  DeleteMentionResponses,
  DeleteTagForItemData,
  DeleteTagForItemErrors,
  DeleteTagForItemResponses,
  DeleteVisibilityData,
  DeleteVisibilityErrors,
  DeleteVisibilityResponses,
  DownloadAppDataFileData,
  DownloadAppDataFileErrors,
  DownloadAppDataFileResponses,
  DownloadAppSettingFileData,
  DownloadAppSettingFileErrors,
  DownloadAppSettingFileResponses,
  DownloadAvatarData,
  DownloadAvatarErrors,
  DownloadAvatarResponses,
  DownloadFileData,
  DownloadFileErrors,
  DownloadFileResponses,
  DownloadItemThumbnailData,
  DownloadItemThumbnailErrors,
  DownloadItemThumbnailResponses,
  EnrollData,
  EnrollResponses,
  ExportActionsData,
  ExportActionsErrors,
  ExportActionsResponses,
  ExportMemberDataData,
  ExportMemberDataErrors,
  ExportMemberDataResponses,
  ExportZipData,
  ExportZipErrors,
  ExportZipResponses,
  GenerateAppTokenData,
  GenerateAppTokenErrors,
  GenerateAppTokenResponses,
  GeolocationReverseData,
  GeolocationReverseErrors,
  GeolocationReverseResponses,
  GeolocationSearchData,
  GeolocationSearchErrors,
  GeolocationSearchResponses,
  GetAccessibleItemsData,
  GetAccessibleItemsErrors,
  GetAccessibleItemsResponses,
  GetAppActionsForAppData,
  GetAppActionsForAppErrors,
  GetAppActionsForAppResponses,
  GetAppContextData,
  GetAppContextResponses,
  GetAppDataForAppData,
  GetAppDataForAppErrors,
  GetAppDataForAppResponses,
  GetAppListData,
  GetAppListErrors,
  GetAppListResponses,
  GetAppSettingsForAppData,
  GetAppSettingsForAppErrors,
  GetAppSettingsForAppResponses,
  GetChatData,
  GetChatErrors,
  GetChatResponses,
  GetChildrenData,
  GetChildrenErrors,
  GetChildrenResponses,
  GetCollectionInformationsData,
  GetCollectionInformationsErrors,
  GetCollectionInformationsResponses,
  GetCollectionsForMemberData,
  GetCollectionsForMemberErrors,
  GetCollectionsForMemberResponses,
  GetCountForTagsData,
  GetCountForTagsErrors,
  GetCountForTagsResponses,
  GetCurrentAccountData,
  GetCurrentAccountErrors,
  GetCurrentAccountResponses,
  GetDescendantItemsData,
  GetDescendantItemsErrors,
  GetDescendantItemsResponses,
  GetEtherpadFromItemData,
  GetEtherpadFromItemErrors,
  GetEtherpadFromItemResponses,
  GetFacetsForNameData,
  GetFacetsForNameErrors,
  GetFacetsForNameResponses,
  GetFeaturedCollectionsData,
  GetFeaturedCollectionsErrors,
  GetFeaturedCollectionsResponses,
  GetFlagTypesData,
  GetFlagTypesErrors,
  GetFlagTypesResponses,
  GetGeolocationByItemData,
  GetGeolocationByItemErrors,
  GetGeolocationByItemResponses,
  GetInvitationByIdData,
  GetInvitationByIdErrors,
  GetInvitationByIdResponses,
  GetInvitationForItemData,
  GetInvitationForItemErrors,
  GetInvitationForItemResponses,
  GetItemActionsByDayData,
  GetItemActionsByDayErrors,
  GetItemActionsByDayResponses,
  GetItemActionsByHourData,
  GetItemActionsByHourErrors,
  GetItemActionsByHourResponses,
  GetItemActionsByWeekdayData,
  GetItemActionsByWeekdayErrors,
  GetItemActionsByWeekdayResponses,
  GetItemData,
  GetItemErrors,
  GetItemLoginSchemaData,
  GetItemLoginSchemaErrors,
  GetItemLoginSchemaResponses,
  GetItemLoginSchemaTypeData,
  GetItemLoginSchemaTypeErrors,
  GetItemLoginSchemaTypeResponses,
  GetItemMembershipsForItemData,
  GetItemMembershipsForItemErrors,
  GetItemMembershipsForItemResponses,
  GetItemResponses,
  GetItemsCollectionsSearchRebuildData,
  GetItemsCollectionsSearchRebuildResponses,
  GetItemsH5pAssetsIntegrationHtmlData,
  GetItemsH5pAssetsIntegrationHtmlResponses,
  GetItemsInBoxData,
  GetItemsInBoxErrors,
  GetItemsInBoxResponses,
  GetItemsPublicationByItemIdStatusData,
  GetItemsPublicationByItemIdStatusResponses,
  GetLatestItemValidationGroupData,
  GetLatestItemValidationGroupErrors,
  GetLatestItemValidationGroupResponses,
  GetLikesForCurrentMemberData,
  GetLikesForCurrentMemberErrors,
  GetLikesForCurrentMemberResponses,
  GetLikesForItemData,
  GetLikesForItemErrors,
  GetLikesForItemResponses,
  GetLinkMetadataData,
  GetLinkMetadataErrors,
  GetLinkMetadataResponses,
  GetMemberProfileData,
  GetMemberProfileErrors,
  GetMemberProfileResponses,
  GetMembersActionsData,
  GetMembersActionsErrors,
  GetMembersActionsResponses,
  GetMembershipRequestsByItemIdData,
  GetMembershipRequestsByItemIdResponses,
  GetMostLikedCollectionsData,
  GetMostLikedCollectionsErrors,
  GetMostLikedCollectionsResponses,
  GetMostRecentCollectionsData,
  GetMostRecentCollectionsErrors,
  GetMostRecentCollectionsResponses,
  GetNextMaintenanceData,
  GetNextMaintenanceErrors,
  GetNextMaintenanceResponses,
  GetOneMemberData,
  GetOneMemberErrors,
  GetOneMemberResponses,
  GetOwnBookmarkData,
  GetOwnBookmarkErrors,
  GetOwnBookmarkResponses,
  GetOwnMembershipRequestByItemIdData,
  GetOwnMembershipRequestByItemIdResponses,
  GetOwnMentionsData,
  GetOwnMentionsErrors,
  GetOwnMentionsResponses,
  GetOwnMostUsedAppsData,
  GetOwnMostUsedAppsErrors,
  GetOwnMostUsedAppsResponses,
  GetOwnPasswordStatusData,
  GetOwnPasswordStatusResponses,
  GetOwnProfileData,
  GetOwnProfileErrors,
  GetOwnProfileResponses,
  GetOwnRecycledItemsData,
  GetOwnRecycledItemsErrors,
  GetOwnRecycledItemsResponses,
  GetParentItemsData,
  GetParentItemsErrors,
  GetParentItemsResponses,
  GetShortLinkAvailabilityData,
  GetShortLinkAvailabilityErrors,
  GetShortLinkAvailabilityResponses,
  GetShortLinkRedirectionData,
  GetShortLinkRedirectionErrors,
  GetShortLinksForItemData,
  GetShortLinksForItemErrors,
  GetShortLinksForItemResponses,
  GetStatusData,
  GetStatusResponses,
  GetStorageData,
  GetStorageErrors,
  GetStorageFilesData,
  GetStorageFilesErrors,
  GetStorageFilesResponses,
  GetStorageResponses,
  GetTagsForItemData,
  GetTagsForItemErrors,
  GetTagsForItemResponses,
  GetUrlData,
  GetUrlErrors,
  GetUrlResponses,
  GetVersionData,
  GetVersionResponses,
  GetWsData,
  GetWsResponses,
  GraaspZipExportData,
  GraaspZipExportErrors,
  GraaspZipExportResponses,
  HealthData,
  HealthResponses,
  ImportH5pData,
  ImportH5pErrors,
  ImportH5pResponses,
  ImportZipData,
  ImportZipErrors,
  ImportZipResponses,
  InviteFromCsvData,
  InviteFromCsvErrors,
  InviteFromCsvResponses,
  InviteFromCsvWithTemplateData,
  InviteFromCsvWithTemplateErrors,
  InviteFromCsvWithTemplateResponses,
  LoginData,
  LoginErrors,
  LoginOrRegisterAsGuestData,
  LoginOrRegisterAsGuestErrors,
  LoginOrRegisterAsGuestResponses,
  LoginResponses,
  MoveManyItemsData,
  MoveManyItemsErrors,
  MoveManyItemsResponses,
  PagesWebsockets2Data,
  PagesWebsockets2Responses,
  PagesWebsocketsData,
  PagesWebsocketsResponses,
  PatchChangeEmailData,
  PatchChangeEmailErrors,
  PatchChangeEmailResponses,
  PatchChatMessageData,
  PatchChatMessageErrors,
  PatchChatMessageResponses,
  PatchMentionData,
  PatchMentionErrors,
  PatchMentionResponses,
  PostActionData,
  PostActionErrors,
  PostActionResponses,
  PostChangeEmailData,
  PostChangeEmailErrors,
  PostChangeEmailResponses,
  PostItemsByIdThumbnailsData,
  PostItemsByIdThumbnailsErrors,
  PostItemsByIdThumbnailsResponses,
  PostMembersAvatarData,
  PostMembersAvatarResponses,
  PublishItemData,
  PublishItemErrors,
  PublishItemResponses,
  PutGeolocationData,
  PutGeolocationErrors,
  PutGeolocationResponses,
  RecycleManyItemsData,
  RecycleManyItemsErrors,
  RecycleManyItemsResponses,
  RegisterData,
  RegisterErrors,
  RegisterResponses,
  ReorderItemData,
  ReorderItemErrors,
  ReorderItemResponses,
  RequestPasswordResetLinkData,
  RequestPasswordResetLinkErrors,
  RequestPasswordResetLinkResponses,
  ResetPasswordData,
  ResetPasswordErrors,
  ResetPasswordResponses,
  RestoreManyItemsData,
  RestoreManyItemsErrors,
  RestoreManyItemsResponses,
  SendInvitationData,
  SendInvitationErrors,
  SendInvitationResponses,
  SignInWithPasswordData,
  SignInWithPasswordErrors,
  SignInWithPasswordResponses,
  SignOutData,
  SignOutErrors,
  SignOutResponses,
  UnpublishItemData,
  UnpublishItemErrors,
  UnpublishItemResponses,
  UpdateAppData,
  UpdateAppDataData,
  UpdateAppDataErrors,
  UpdateAppDataResponses,
  UpdateAppErrors,
  UpdateAppResponses,
  UpdateAppSettingData,
  UpdateAppSettingErrors,
  UpdateAppSettingResponses,
  UpdateCurrentAccountData,
  UpdateCurrentAccountErrors,
  UpdateCurrentAccountResponses,
  UpdateDocumentData,
  UpdateDocumentErrors,
  UpdateDocumentResponses,
  UpdateEtherpadData,
  UpdateEtherpadErrors,
  UpdateEtherpadResponses,
  UpdateFileData,
  UpdateFileErrors,
  UpdateFileResponses,
  UpdateFolderData,
  UpdateFolderErrors,
  UpdateFolderResponses,
  UpdateInvitationData,
  UpdateInvitationErrors,
  UpdateInvitationResponses,
  UpdateItemData,
  UpdateItemErrors,
  UpdateItemLoginSchemaData,
  UpdateItemLoginSchemaErrors,
  UpdateItemLoginSchemaResponses,
  UpdateItemMembershipData,
  UpdateItemMembershipErrors,
  UpdateItemMembershipResponses,
  UpdateItemResponses,
  UpdateLinkData,
  UpdateLinkErrors,
  UpdateLinkResponses,
  UpdateOwnProfileData,
  UpdateOwnProfileErrors,
  UpdateOwnProfileResponses,
  UpdatePasswordData,
  UpdatePasswordErrors,
  UpdatePasswordResponses,
  UpdateShortLinkData,
  UpdateShortLinkErrors,
  UpdateShortLinkResponses,
  UpdateShortcutData,
  UpdateShortcutErrors,
  UpdateShortcutResponses,
  UploadFileData,
  UploadFileErrors,
  UploadFileResponses,
  ValidateItemData,
  ValidateItemErrors,
  ValidateItemResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Health check endpoint
 * Return a simple 200: OK when the server is running
 */
export const health = <ThrowOnError extends boolean = false>(
  options?: Options<HealthData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthResponses,
    unknown,
    ThrowOnError
  >({
    url: '/health',
    ...options,
  });
};

export const getStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatusData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: '/status',
    ...options,
  });
};

export const getVersion = <ThrowOnError extends boolean = false>(
  options?: Options<GetVersionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetVersionResponses,
    unknown,
    ThrowOnError
  >({
    url: '/version',
    ...options,
  });
};

/**
 * get next maintenance period
 * Return next maintenance period, usually to perform a migration
 */
export const getNextMaintenance = <ThrowOnError extends boolean = false>(
  options?: Options<GetNextMaintenanceData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetNextMaintenanceResponses,
    GetNextMaintenanceErrors,
    ThrowOnError
  >({
    url: '/maintenance/next',
    ...options,
  });
};

/**
 * Register with email and name
 * Register with email and name, protected by a captcha. The captcha is used to prevent brute force attacks.
 */
export const register = <ThrowOnError extends boolean = false>(
  options: Options<RegisterData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RegisterResponses,
    RegisterErrors,
    ThrowOnError
  >({
    url: '/register',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Login with email
 * Login with email, protected by a captcha. The captcha is used to prevent brute force attacks.
 */
export const login = <ThrowOnError extends boolean = false>(
  options: Options<LoginData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    LoginResponses,
    LoginErrors,
    ThrowOnError
  >({
    url: '/login',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Authentication validating the token
 * Authenticate to obtain session cookie given provided token and verifier
 */
export const authenticate = <ThrowOnError extends boolean = false>(
  options: Options<AuthenticateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    unknown,
    AuthenticateErrors,
    ThrowOnError
  >({
    url: '/auth',
    ...options,
  });
};

/**
 * Log out
 * Log out from current session
 */
export const signOut = <ThrowOnError extends boolean = false>(
  options?: Options<SignOutData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    SignOutResponses,
    SignOutErrors,
    ThrowOnError
  >({
    url: '/logout',
    ...options,
  });
};

/**
 * Log in with email and password
 * Log in with email and password. The user must provide a valid email, password, and captcha. The captcha is used to prevent brute force attacks.
 */
export const signInWithPassword = <ThrowOnError extends boolean = false>(
  options: Options<SignInWithPasswordData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SignInWithPasswordResponses,
    SignInWithPasswordErrors,
    ThrowOnError
  >({
    url: '/login-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update the password of the authenticated member
 * Update the password of the authenticated member. The user must provide the current password and the new password.
 */
export const updatePassword = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePasswordData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdatePasswordResponses,
    UpdatePasswordErrors,
    ThrowOnError
  >({
    url: '/password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set a password for the authenticated member
 * Set a password for the authenticated member. This is only possible if the member does not have a password set already.
 */
export const createPassword = <ThrowOnError extends boolean = false>(
  options: Options<CreatePasswordData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePasswordResponses,
    CreatePasswordErrors,
    ThrowOnError
  >({
    url: '/password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Confirm the reset password request
 * Confirm the reset password request. This will change the password of the member associated with the reset password request.
 */
export const resetPassword = <ThrowOnError extends boolean = false>(
  options: Options<ResetPasswordData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    ResetPasswordResponses,
    ResetPasswordErrors,
    ThrowOnError
  >({
    url: '/password/reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create a reset password request
 * Create a reset password request. This will send an email to the member in his language with a link to reset the password. The link will be valid for a limited time.
 */
export const requestPasswordResetLink = <ThrowOnError extends boolean = false>(
  options: Options<RequestPasswordResetLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RequestPasswordResetLinkResponses,
    RequestPasswordResetLinkErrors,
    ThrowOnError
  >({
    url: '/password/reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get the current password status of the authenticated member
 * Return whether the authenticated member has a password defined.
 */
export const getOwnPasswordStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetOwnPasswordStatusData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOwnPasswordStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: '/members/current/password/status',
    ...options,
  });
};

export const getWs = <ThrowOnError extends boolean = false>(
  options?: Options<GetWsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetWsResponses,
    unknown,
    ThrowOnError
  >({
    url: '/ws',
    ...options,
  });
};

export const getMembersActions = <ThrowOnError extends boolean = false>(
  options?: Options<GetMembersActionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetMembersActionsResponses,
    GetMembersActionsErrors,
    ThrowOnError
  >({
    url: '/members/actions',
    ...options,
  });
};

export const deleteMembersMembersByIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteMembersMembersByIdDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteMembersMembersByIdDeleteResponses,
    unknown,
    ThrowOnError
  >({
    url: '/members/members/{id}/delete',
    ...options,
  });
};

/**
 * Delete authenticated account
 * Delete authenticated account. This action is irreversible!
 */
export const deleteCurrentAccount = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteCurrentAccountData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).delete<
    DeleteCurrentAccountResponses,
    DeleteCurrentAccountErrors,
    ThrowOnError
  >({
    url: '/members/current',
    ...options,
  });
};

/**
 * Get information of current authenticated account
 * Get information of current authenticated account, that can be a member or a guest.
 */
export const getCurrentAccount = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentAccountData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetCurrentAccountResponses,
    GetCurrentAccountErrors,
    ThrowOnError
  >({
    url: '/members/current',
    ...options,
  });
};

/**
 * Update authenticated account
 * Update authenticated account, such as name or language.
 */
export const updateCurrentAccount = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateCurrentAccountData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).patch<
    UpdateCurrentAccountResponses,
    UpdateCurrentAccountErrors,
    ThrowOnError
  >({
    url: '/members/current',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Get storage values
 * Get amount of storage used for current member, and its maximum storage value.
 */
export const getStorage = <ThrowOnError extends boolean = false>(
  options?: Options<GetStorageData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetStorageResponses,
    GetStorageErrors,
    ThrowOnError
  >({
    url: '/members/current/storage',
    ...options,
  });
};

/**
 * Get storage files data
 * Get files data counted in storage of current member.
 */
export const getStorageFiles = <ThrowOnError extends boolean = false>(
  options: Options<GetStorageFilesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetStorageFilesResponses,
    GetStorageFilesErrors,
    ThrowOnError
  >({
    url: '/members/current/storage/files',
    ...options,
  });
};

/**
 * Get member by id
 * Get member by id.
 */
export const getOneMember = <ThrowOnError extends boolean = false>(
  options: Options<GetOneMemberData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetOneMemberResponses,
    GetOneMemberErrors,
    ThrowOnError
  >({
    url: '/members/{id}',
    ...options,
  });
};

/**
 * Change email
 * Change email for current authenticated member.
 */
export const patchChangeEmail = <ThrowOnError extends boolean = false>(
  options?: Options<PatchChangeEmailData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).patch<
    PatchChangeEmailResponses,
    PatchChangeEmailErrors,
    ThrowOnError
  >({
    url: '/members/current/email/change',
    ...options,
  });
};

/**
 * Request to change email
 * Request to change email for current authenticated member.
 */
export const postChangeEmail = <ThrowOnError extends boolean = false>(
  options: Options<PostChangeEmailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostChangeEmailResponses,
    PostChangeEmailErrors,
    ThrowOnError
  >({
    url: '/members/current/email/change',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

export const postMembersAvatar = <ThrowOnError extends boolean = false>(
  options?: Options<PostMembersAvatarData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    PostMembersAvatarResponses,
    unknown,
    ThrowOnError
  >({
    url: '/members/avatar',
    ...options,
  });
};

/**
 * Get a member's avatar
 * Get a member's avatar at given size. The return value is empty if the member did not previously uploaded an avatar. Since guests don't have avatars, the return value will also be empty.
 */
export const downloadAvatar = <ThrowOnError extends boolean = false>(
  options: Options<DownloadAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DownloadAvatarResponses,
    DownloadAvatarErrors,
    ThrowOnError
  >({
    url: '/members/{id}/avatar/{size}',
    ...options,
  });
};

/**
 * Get profile of current member
 * Get profile of current member
 */
export const getOwnProfile = <ThrowOnError extends boolean = false>(
  options?: Options<GetOwnProfileData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOwnProfileResponses,
    GetOwnProfileErrors,
    ThrowOnError
  >({
    url: '/members/profile/own',
    ...options,
  });
};

/**
 * Get profile of given member
 * Get profile of given member
 */
export const getMemberProfile = <ThrowOnError extends boolean = false>(
  options: Options<GetMemberProfileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetMemberProfileResponses,
    GetMemberProfileErrors,
    ThrowOnError
  >({
    url: '/members/profile/{memberId}',
    ...options,
  });
};

/**
 * Update profile of current member
 * Update profile of current member
 */
export const updateOwnProfile = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateOwnProfileData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).patch<
    UpdateOwnProfileResponses,
    UpdateOwnProfileErrors,
    ThrowOnError
  >({
    url: '/members/profile/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Create profile for current member
 * Create profile for current member.
 */
export const createOwnProfile = <ThrowOnError extends boolean = false>(
  options?: Options<CreateOwnProfileData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    CreateOwnProfileResponses,
    CreateOwnProfileErrors,
    ThrowOnError
  >({
    url: '/members/profile/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Request all related data of authenticated member
 * Request a download link to have access to all data related to the authenticated user. The link is valid for one week.
 */
export const exportMemberData = <ThrowOnError extends boolean = false>(
  options?: Options<ExportMemberDataData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    ExportMemberDataResponses,
    ExportMemberDataErrors,
    ThrowOnError
  >({
    url: '/members/export-data/',
    ...options,
  });
};

/**
 * Get list of available apps
 * Get list of available apps
 */
export const getAppList = <ThrowOnError extends boolean = false>(
  options?: Options<GetAppListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAppListResponses,
    GetAppListErrors,
    ThrowOnError
  >({
    url: '/app-items/list',
    ...options,
  });
};

/**
 * Get the user's most used apps
 * Get a list of the apps the user has used the most to ease the addition of new apps.
 */
export const getOwnMostUsedApps = <ThrowOnError extends boolean = false>(
  options?: Options<GetOwnMostUsedAppsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOwnMostUsedAppsResponses,
    GetOwnMostUsedAppsErrors,
    ThrowOnError
  >({
    url: '/app-items/most-used',
    ...options,
  });
};

/**
 * Generate auth token for an app
 * Generate auth token for an app to access app API
 */
export const generateAppToken = <ThrowOnError extends boolean = false>(
  options: Options<GenerateAppTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateAppTokenResponses,
    GenerateAppTokenErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/api-access-token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get context information of an app
 * Get context information of an app
 */
export const getAppContext = <ThrowOnError extends boolean = false>(
  options: Options<GetAppContextData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAppContextResponses,
    unknown,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/context',
    ...options,
  });
};

/**
 * Get all app data of an app
 * Get app data saved for an app, depending on the permission of the user and the data visibility.
 */
export const getAppDataForApp = <ThrowOnError extends boolean = false>(
  options: Options<GetAppDataForAppData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAppDataForAppResponses,
    GetAppDataForAppErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/app-data',
    ...options,
  });
};

/**
 * Create a user data for an app
 * Create a user data in an app given data and type.
 */
export const createAppData = <ThrowOnError extends boolean = false>(
  options: Options<CreateAppDataData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAppDataResponses,
    CreateAppDataErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/app-data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete an app data
 * Delete a given app data.
 */
export const deleteAppData = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAppDataData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAppDataResponses,
    DeleteAppDataErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/app-data/{id}',
    ...options,
  });
};

/**
 * Update an app data
 * Update a given app data with new data.
 */
export const updateAppData = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAppDataData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateAppDataResponses,
    UpdateAppDataErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/app-data/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create app data file
 * Upload a file to create a corresponding app data. The created app data will have a type file and visibility member. The data property will contain the file properties.
 */
export const createAppDataFile = <ThrowOnError extends boolean = false>(
  options?: Options<CreateAppDataFileData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    CreateAppDataFileResponses,
    CreateAppDataFileErrors,
    ThrowOnError
  >({
    url: '/app-items/app-data/upload',
    ...options,
  });
};

/**
 * Download app data file
 * Download app data file.
 */
export const downloadAppDataFile = <ThrowOnError extends boolean = false>(
  options: Options<DownloadAppDataFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DownloadAppDataFileResponses,
    DownloadAppDataFileErrors,
    ThrowOnError
  >({
    url: '/app-items/app-data/{id}/download',
    ...options,
  });
};

/**
 * Get all actions of an app
 * Get all actions saved for an app.
 */
export const getAppActionsForApp = <ThrowOnError extends boolean = false>(
  options: Options<GetAppActionsForAppData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAppActionsForAppResponses,
    GetAppActionsForAppErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/app-action',
    ...options,
  });
};

/**
 * Create an action happening in an app
 * Create an action happening in an app given data and type.
 */
export const createAppAction = <ThrowOnError extends boolean = false>(
  options: Options<CreateAppActionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAppActionResponses,
    CreateAppActionErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/app-action',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get all settings of an app
 * Get all settings for an app.
 */
export const getAppSettingsForApp = <ThrowOnError extends boolean = false>(
  options: Options<GetAppSettingsForAppData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAppSettingsForAppResponses,
    GetAppSettingsForAppErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/app-settings',
    ...options,
  });
};

/**
 * Create a setting for an app
 * Create a setting in an app given data and name. Only admins can create settings.
 */
export const createAppSetting = <ThrowOnError extends boolean = false>(
  options: Options<CreateAppSettingData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAppSettingResponses,
    CreateAppSettingErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/app-settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete app setting
 * Delete given app setting.
 */
export const deleteAppSetting = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAppSettingData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAppSettingResponses,
    DeleteAppSettingErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/app-settings/{id}',
    ...options,
  });
};

/**
 * Update app setting
 * Update given app setting with new data. Only admins can update settings.
 */
export const updateAppSetting = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAppSettingData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateAppSettingResponses,
    UpdateAppSettingErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/app-settings/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create app setting file
 * Upload a file to create a corresponding app setting. The setting's name can be defined in the file body (form data) as "name", otherwise it will default to "file"
 */
export const createAppSettingFile = <ThrowOnError extends boolean = false>(
  options?: Options<CreateAppSettingFileData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    CreateAppSettingFileResponses,
    CreateAppSettingFileErrors,
    ThrowOnError
  >({
    url: '/app-items/app-settings/upload',
    ...options,
  });
};

/**
 * Download app setting file
 * Download app setting file.
 */
export const downloadAppSettingFile = <ThrowOnError extends boolean = false>(
  options: Options<DownloadAppSettingFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DownloadAppSettingFileResponses,
    DownloadAppSettingFileErrors,
    ThrowOnError
  >({
    url: '/app-items/app-settings/{id}/download',
    ...options,
  });
};

/**
 * Get a prompt completion from a chatbot
 * Given a prompt, it returns a completion from a chatbot.
 */
export const createChatbotCompletionPrompt = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateChatbotCompletionPromptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateChatbotCompletionPromptResponses,
    CreateChatbotCompletionPromptErrors,
    ThrowOnError
  >({
    url: '/app-items/{itemId}/chat-bot',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get type of item login
 * Get type of item login. Return null if the item does not allow item login.
 */
export const getItemLoginSchemaType = <ThrowOnError extends boolean = false>(
  options: Options<GetItemLoginSchemaTypeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemLoginSchemaTypeResponses,
    GetItemLoginSchemaTypeErrors,
    ThrowOnError
  >({
    url: '/items/{id}/login-schema-type',
    ...options,
  });
};

/**
 * Delete item login schema
 * Delete item login data and all related users.
 */
export const deleteItemLoginSchema = <ThrowOnError extends boolean = false>(
  options: Options<DeleteItemLoginSchemaData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteItemLoginSchemaResponses,
    DeleteItemLoginSchemaErrors,
    ThrowOnError
  >({
    url: '/items/{id}/login-schema',
    ...options,
  });
};

/**
 * Get item login data
 * Get item login data.
 */
export const getItemLoginSchema = <ThrowOnError extends boolean = false>(
  options: Options<GetItemLoginSchemaData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemLoginSchemaResponses,
    GetItemLoginSchemaErrors,
    ThrowOnError
  >({
    url: '/items/{id}/login-schema',
    ...options,
  });
};

/**
 * Update item login data
 * Update item login's status and/or type.
 */
export const updateItemLoginSchema = <ThrowOnError extends boolean = false>(
  options: Options<UpdateItemLoginSchemaData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateItemLoginSchemaResponses,
    UpdateItemLoginSchemaErrors,
    ThrowOnError
  >({
    url: '/items/{id}/login-schema',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Login or Register in item as guest
 * Log in to an item with necessary credentials depending on item login's type. If the username does not exist, a guest account is created and is given access.
 */
export const loginOrRegisterAsGuest = <ThrowOnError extends boolean = false>(
  options: Options<LoginOrRegisterAsGuestData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    LoginOrRegisterAsGuestResponses,
    LoginOrRegisterAsGuestErrors,
    ThrowOnError
  >({
    url: '/items/{id}/login',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get all bookmarked instances of the current member
 * Get all bookmarked instances of the current member
 */
export const getOwnBookmark = <ThrowOnError extends boolean = false>(
  options?: Options<GetOwnBookmarkData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOwnBookmarkResponses,
    GetOwnBookmarkErrors,
    ThrowOnError
  >({
    url: '/items/bookmarks',
    ...options,
  });
};

/**
 * Remove item from bookmarks
 * Remove item from bookmarks
 */
export const deleteBookmark = <ThrowOnError extends boolean = false>(
  options: Options<DeleteBookmarkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteBookmarkResponses,
    DeleteBookmarkErrors,
    ThrowOnError
  >({
    url: '/items/bookmarks/{itemId}',
    ...options,
  });
};

/**
 * Bookmark item
 * Bookmark item
 */
export const createBookmark = <ThrowOnError extends boolean = false>(
  options: Options<CreateBookmarkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateBookmarkResponses,
    CreateBookmarkErrors,
    ThrowOnError
  >({
    url: '/items/bookmarks/{itemId}',
    ...options,
  });
};

/**
 * Get collections for member
 * Get packed collections for member, used in the builder view of the member.
 */
export const getCollectionsForMember = <ThrowOnError extends boolean = false>(
  options: Options<GetCollectionsForMemberData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCollectionsForMemberResponses,
    GetCollectionsForMemberErrors,
    ThrowOnError
  >({
    url: '/items/collections/members/{memberId}',
    ...options,
  });
};

/**
 * Get information of a collection
 * Get information of a collection, including views count.
 */
export const getCollectionInformations = <ThrowOnError extends boolean = false>(
  options: Options<GetCollectionInformationsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCollectionInformationsResponses,
    GetCollectionInformationsErrors,
    ThrowOnError
  >({
    url: '/items/collections/{itemId}/informations',
    ...options,
  });
};

/**
 * Publish an item
 * Publish an item. It will become listed in the Library.
 */
export const publishItem = <ThrowOnError extends boolean = false>(
  options: Options<PublishItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PublishItemResponses,
    PublishItemErrors,
    ThrowOnError
  >({
    url: '/items/collections/{itemId}/publish',
    ...options,
  });
};

/**
 * Unpublish an item
 * Unpublish an item. It will stop being available in the Library.
 */
export const unpublishItem = <ThrowOnError extends boolean = false>(
  options: Options<UnpublishItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    UnpublishItemResponses,
    UnpublishItemErrors,
    ThrowOnError
  >({
    url: '/items/collections/{itemId}/unpublish',
    ...options,
  });
};

/**
 * Get collections given search query
 * Get collections given search query. the results are highlighted given the search query.
 */
export const collectionSearch = <ThrowOnError extends boolean = false>(
  options?: Options<CollectionSearchData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    CollectionSearchResponses,
    CollectionSearchErrors,
    ThrowOnError
  >({
    url: '/items/collections/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Get facets for a given facet name
 * Get list of facets and how many collections are tagged with those given a facet name.
 */
export const getFacetsForName = <ThrowOnError extends boolean = false>(
  options: Options<GetFacetsForNameData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GetFacetsForNameResponses,
    GetFacetsForNameErrors,
    ThrowOnError
  >({
    url: '/items/collections/facets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get featured collections
 * Get collections that we want to feature on the library home page.
 */
export const getFeaturedCollections = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeaturedCollectionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetFeaturedCollectionsResponses,
    GetFeaturedCollectionsErrors,
    ThrowOnError
  >({
    url: '/items/collections/featured',
    ...options,
  });
};

/**
 * Get most liked collections
 * Get most liked collections.
 */
export const getMostLikedCollections = <ThrowOnError extends boolean = false>(
  options?: Options<GetMostLikedCollectionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetMostLikedCollectionsResponses,
    GetMostLikedCollectionsErrors,
    ThrowOnError
  >({
    url: '/items/collections/liked',
    ...options,
  });
};

/**
 * Get most recent collections
 * Get most recently published and modified collections
 */
export const getMostRecentCollections = <ThrowOnError extends boolean = false>(
  options?: Options<GetMostRecentCollectionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetMostRecentCollectionsResponses,
    GetMostRecentCollectionsErrors,
    ThrowOnError
  >({
    url: '/items/collections/recent',
    ...options,
  });
};

export const getItemsCollectionsSearchRebuild = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetItemsCollectionsSearchRebuildData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetItemsCollectionsSearchRebuildResponses,
    unknown,
    ThrowOnError
  >({
    url: '/items/collections/search/rebuild',
    ...options,
  });
};

/**
 * Get memberships for one item
 * Get memberships for one item
 */
export const getItemMembershipsForItem = <ThrowOnError extends boolean = false>(
  options: Options<GetItemMembershipsForItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemMembershipsForItemResponses,
    GetItemMembershipsForItemErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/memberships',
    ...options,
  });
};

/**
 * Create access to item for account
 * Create access to item for account, given permission
 */
export const createItemMembership = <ThrowOnError extends boolean = false>(
  options: Options<CreateItemMembershipData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateItemMembershipResponses,
    CreateItemMembershipErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/memberships',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete access to item for account
 * Delete access to item for account
 */
export const deleteItemMembership = <ThrowOnError extends boolean = false>(
  options: Options<DeleteItemMembershipData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteItemMembershipResponses,
    DeleteItemMembershipErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/memberships/{id}',
    ...options,
  });
};

/**
 * Update permission for item membership
 * Update permission for item membership
 */
export const updateItemMembership = <ThrowOnError extends boolean = false>(
  options: Options<UpdateItemMembershipData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateItemMembershipResponses,
    UpdateItemMembershipErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/memberships/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get all membership requests for an item
 * Get all membership requests with member information for an item by its ID
 */
export const getMembershipRequestsByItemId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMembershipRequestsByItemIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetMembershipRequestsByItemIdResponses,
    unknown,
    ThrowOnError
  >({
    url: '/items/{itemId}/memberships/requests',
    ...options,
  });
};

/**
 * Create a membership request
 * Create a membership request for an item with the authenticated member.
 * The member should not have any permission on the item.
 * If there is an Item Login associated with the item, the request will be rejected.
 */
export const createMembershipRequest = <ThrowOnError extends boolean = false>(
  options: Options<CreateMembershipRequestData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateMembershipRequestResponses,
    unknown,
    ThrowOnError
  >({
    url: '/items/{itemId}/memberships/requests',
    ...options,
  });
};

/**
 * Get the status of the membership request for the authenticated member
 * Get the status of the membership request for the authenticated member for an item by its ID
 */
export const getOwnMembershipRequestByItemId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOwnMembershipRequestByItemIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetOwnMembershipRequestByItemIdResponses,
    unknown,
    ThrowOnError
  >({
    url: '/items/{itemId}/memberships/requests/own',
    ...options,
  });
};

/**
 * Delete a membership request
 * Delete a membership request from a member id and an item id.
 */
export const deleteMembershipRequest = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMembershipRequestData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteMembershipRequestResponses,
    unknown,
    ThrowOnError
  >({
    url: '/items/{itemId}/memberships/requests/{memberId}',
    ...options,
  });
};

/**
 * Create shortcut
 * Create shortcut. If not provided, the name of the shortcut is infered from the actor's language.
 */
export const createShortcut = <ThrowOnError extends boolean = false>(
  options: Options<CreateShortcutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateShortcutResponses,
    CreateShortcutErrors,
    ThrowOnError
  >({
    url: '/items/shortcuts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update shortcut
 * Update shortcut given body.
 */
export const updateShortcut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateShortcutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateShortcutResponses,
    UpdateShortcutErrors,
    ThrowOnError
  >({
    url: '/items/shortcuts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

export const deleteItemsByIdThumbnails = <ThrowOnError extends boolean = false>(
  options: Options<DeleteItemsByIdThumbnailsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteItemsByIdThumbnailsResponses,
    unknown,
    ThrowOnError
  >({
    url: '/items/{id}/thumbnails',
    ...options,
  });
};

export const postItemsByIdThumbnails = <ThrowOnError extends boolean = false>(
  options: Options<PostItemsByIdThumbnailsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostItemsByIdThumbnailsResponses,
    PostItemsByIdThumbnailsErrors,
    ThrowOnError
  >({
    url: '/items/{id}/thumbnails',
    ...options,
  });
};

/**
 * Get an item's thumbnail
 * Get an item's thumbnail at given size. The return value is null if the item did not previously have a thumbnail.
 */
export const downloadItemThumbnail = <ThrowOnError extends boolean = false>(
  options: Options<DownloadItemThumbnailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DownloadItemThumbnailResponses,
    DownloadItemThumbnailErrors,
    ThrowOnError
  >({
    url: '/items/{id}/thumbnails/{size}',
    ...options,
  });
};

/**
 * Upload files
 * Upload files to create corresponding items.
 */
export const uploadFile = <ThrowOnError extends boolean = false>(
  options?: Options<UploadFileData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    UploadFileResponses,
    UploadFileErrors,
    ThrowOnError
  >({
    url: '/items/upload',
    ...options,
  });
};

/**
 * Get file URL
 * Get file URL.
 */
export const getUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetUrlData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetUrlResponses,
    GetUrlErrors,
    ThrowOnError
  >({
    url: '/items/{id}/download',
    ...options,
  });
};

/**
 * Update file
 * Update file.
 */
export const updateFile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateFileResponses,
    UpdateFileErrors,
    ThrowOnError
  >({
    url: '/items/files/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete visibility of item
 * Delete visibility of item with given type.
 */
export const deleteVisibility = <ThrowOnError extends boolean = false>(
  options: Options<DeleteVisibilityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteVisibilityResponses,
    DeleteVisibilityErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/visibilities/{type}',
    ...options,
  });
};

/**
 * Create visibility on item
 * Create visibility on item with given visibility that will apply on itself and its descendants.
 */
export const createVisibility = <ThrowOnError extends boolean = false>(
  options: Options<CreateVisibilityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateVisibilityResponses,
    CreateVisibilityErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/visibilities/{type}',
    ...options,
  });
};

/**
 * Create folder
 * Create folder.
 */
export const createFolder = <ThrowOnError extends boolean = false>(
  options: Options<CreateFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateFolderResponses,
    CreateFolderErrors,
    ThrowOnError
  >({
    url: '/items/folders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update folder
 * Update folder given body.
 */
export const updateFolder = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateFolderResponses,
    UpdateFolderErrors,
    ThrowOnError
  >({
    url: '/items/folders/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create a folder with a thumbnail
 * Create a folder with a thumbnail. The data is sent using a form-data.
 */
export const createFolderWithThumbnail = <ThrowOnError extends boolean = false>(
  options?: Options<CreateFolderWithThumbnailData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    CreateFolderWithThumbnailResponses,
    CreateFolderWithThumbnailErrors,
    ThrowOnError
  >({
    url: '/items/folders-with-thumbnail',
    ...options,
  });
};

/**
 * Create app
 * Create app.
 */
export const createApp = <ThrowOnError extends boolean = false>(
  options: Options<CreateAppData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAppResponses,
    CreateAppErrors,
    ThrowOnError
  >({
    url: '/items/apps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update app
 * Update app given body.
 */
export const updateApp = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAppData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateAppResponses,
    UpdateAppErrors,
    ThrowOnError
  >({
    url: '/items/apps/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete alias
 * Delete short link's alias.
 */
export const deleteAlias = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAliasData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAliasResponses,
    DeleteAliasErrors,
    ThrowOnError
  >({
    url: '/items/short-links/{alias}',
    ...options,
  });
};

/**
 * Get redirection for short link
 * Get redirection for given short link.
 */
export const getShortLinkRedirection = <ThrowOnError extends boolean = false>(
  options: Options<GetShortLinkRedirectionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    unknown,
    GetShortLinkRedirectionErrors,
    ThrowOnError
  >({
    url: '/items/short-links/{alias}',
    ...options,
  });
};

/**
 * Update short link
 * Update the alias of the short link.
 */
export const updateShortLink = <ThrowOnError extends boolean = false>(
  options: Options<UpdateShortLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateShortLinkResponses,
    UpdateShortLinkErrors,
    ThrowOnError
  >({
    url: '/items/short-links/{alias}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get whether an alias is available
 * Get whether an alias is available.
 */
export const getShortLinkAvailability = <ThrowOnError extends boolean = false>(
  options: Options<GetShortLinkAvailabilityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetShortLinkAvailabilityResponses,
    GetShortLinkAvailabilityErrors,
    ThrowOnError
  >({
    url: '/items/short-links/available/{alias}',
    ...options,
  });
};

/**
 * Get all short links for item
 * Get all short links created for an item. The response could be an empty object or a key-value with at least one platform and the alias.
 */
export const getShortLinksForItem = <ThrowOnError extends boolean = false>(
  options: Options<GetShortLinksForItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetShortLinksForItemResponses,
    GetShortLinksForItemErrors,
    ThrowOnError
  >({
    url: '/items/short-links/list/{itemId}',
    ...options,
  });
};

/**
 * Create short link for item
 * Create short link for item.
 */
export const createShortLink = <ThrowOnError extends boolean = false>(
  options: Options<CreateShortLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateShortLinkResponses,
    CreateShortLinkErrors,
    ThrowOnError
  >({
    url: '/items/short-links/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

export const getItemsPublicationByItemIdStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetItemsPublicationByItemIdStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemsPublicationByItemIdStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: '/items/publication/{itemId}/status',
    ...options,
  });
};

export const getItemsH5pAssetsIntegrationHtml = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetItemsH5pAssetsIntegrationHtmlData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetItemsH5pAssetsIntegrationHtmlResponses,
    unknown,
    ThrowOnError
  >({
    url: '/items/h5p-assets/integration.html',
    ...options,
  });
};

/**
 * Import H5P file
 * Import H5P file and create corresponding item.
 */
export const importH5P = <ThrowOnError extends boolean = false>(
  options?: Options<ImportH5pData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    ImportH5pResponses,
    ImportH5pErrors,
    ThrowOnError
  >({
    url: '/items/h5p-import',
    ...options,
  });
};

/**
 * Create etherpad
 * Create an etherpad item.
 */
export const createEtherpad = <ThrowOnError extends boolean = false>(
  options: Options<CreateEtherpadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateEtherpadResponses,
    CreateEtherpadErrors,
    ThrowOnError
  >({
    url: '/items/etherpad/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update etherpad
 * Update etherpad properties, including permission of readers.
 */
export const updateEtherpad = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEtherpadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateEtherpadResponses,
    UpdateEtherpadErrors,
    ThrowOnError
  >({
    url: '/items/etherpad/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get etherpad information
 * Get etherpad information from item id
 */
export const getEtherpadFromItem = <ThrowOnError extends boolean = false>(
  options: Options<GetEtherpadFromItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEtherpadFromItemResponses,
    GetEtherpadFromItemErrors,
    ThrowOnError
  >({
    url: '/items/etherpad/view/{itemId}',
    ...options,
  });
};

/**
 * Import ZIP content
 * Import and extract the content of a ZIP, creating the corresponding structure and items.
 */
export const importZip = <ThrowOnError extends boolean = false>(
  options?: Options<ImportZipData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    ImportZipResponses,
    ImportZipErrors,
    ThrowOnError
  >({
    url: '/items/zip-import',
    ...options,
  });
};

/**
 * Download non-folder content
 * Download non-folder content. Return raw file for single item.
 */
export const downloadFile = <ThrowOnError extends boolean = false>(
  options: Options<DownloadFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DownloadFileResponses,
    DownloadFileErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/download-file',
    ...options,
  });
};

/**
 * Export folder content as zip archive
 * Export the folder's content as a ZIP archive. The user will receive an email with a link to download the ZIP archive. Users can download any resource they can access.
 */
export const exportZip = <ThrowOnError extends boolean = false>(
  options: Options<ExportZipData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ExportZipResponses,
    ExportZipErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/export',
    ...options,
  });
};

/**
 * Export content
 * Export content. Return raw file for single item, or a ZIP with structure and items for a folder.
 */
export const graaspZipExport = <ThrowOnError extends boolean = false>(
  options: Options<GraaspZipExportData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GraaspZipExportResponses,
    GraaspZipExportErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/graasp-export',
    ...options,
  });
};

/**
 * Get metadata information from iframely for given url
 * Get metadata information from iframely for given url.
 */
export const getLinkMetadata = <ThrowOnError extends boolean = false>(
  options: Options<GetLinkMetadataData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetLinkMetadataResponses,
    GetLinkMetadataErrors,
    ThrowOnError
  >({
    url: '/items/embedded-links/metadata',
    ...options,
  });
};

/**
 * Create link
 * Create link.
 */
export const createLink = <ThrowOnError extends boolean = false>(
  options: Options<CreateLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateLinkResponses,
    CreateLinkErrors,
    ThrowOnError
  >({
    url: '/items/embedded-links/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update link
 * Update link given body.
 */
export const updateLink = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateLinkResponses,
    UpdateLinkErrors,
    ThrowOnError
  >({
    url: '/items/embedded-links/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create document
 * Create document with given payload. The content will be sanitized.
 */
export const createDocument = <ThrowOnError extends boolean = false>(
  options: Options<CreateDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateDocumentResponses,
    CreateDocumentErrors,
    ThrowOnError
  >({
    url: '/items/documents/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update document
 * Update document given payload. The content will be sanitized.
 */
export const updateDocument = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateDocumentResponses,
    UpdateDocumentErrors,
    ThrowOnError
  >({
    url: '/items/documents/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get invitation
 * Get invitation by id
 */
export const getInvitationById = <ThrowOnError extends boolean = false>(
  options: Options<GetInvitationByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetInvitationByIdResponses,
    GetInvitationByIdErrors,
    ThrowOnError
  >({
    url: '/items/invitations/{id}',
    ...options,
  });
};

/**
 * Invite user by email to access an item
 * Invite non-registered user with their email to access given item.
 */
export const createInvitation = <ThrowOnError extends boolean = false>(
  options: Options<CreateInvitationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateInvitationResponses,
    CreateInvitationErrors,
    ThrowOnError
  >({
    url: '/items/{id}/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get invitations for a given item
 * Get invitation for a given item
 */
export const getInvitationForItem = <ThrowOnError extends boolean = false>(
  options: Options<GetInvitationForItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetInvitationForItemResponses,
    GetInvitationForItemErrors,
    ThrowOnError
  >({
    url: '/items/{id}/invitations',
    ...options,
  });
};

/**
 * Delete invitation
 * Delete invitation
 */
export const deleteInvitation = <ThrowOnError extends boolean = false>(
  options: Options<DeleteInvitationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteInvitationResponses,
    DeleteInvitationErrors,
    ThrowOnError
  >({
    url: '/items/{id}/invitations/{invitationId}',
    ...options,
  });
};

/**
 * Update invitation
 * Update invitation's name or permission
 */
export const updateInvitation = <ThrowOnError extends boolean = false>(
  options: Options<UpdateInvitationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateInvitationResponses,
    UpdateInvitationErrors,
    ThrowOnError
  >({
    url: '/items/{id}/invitations/{invitationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Send invitation
 * Send invitation
 */
export const sendInvitation = <ThrowOnError extends boolean = false>(
  options: Options<SendInvitationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SendInvitationResponses,
    SendInvitationErrors,
    ThrowOnError
  >({
    url: '/items/{id}/invitations/{invitationId}/send',
    ...options,
  });
};

/**
 * Invite users from CSV file in groups given a template
 * Invite users by groups from CSV. This will create groups of users having access to corresponding resources from a given template.
 */
export const inviteFromCsvWithTemplate = <ThrowOnError extends boolean = false>(
  options: Options<InviteFromCsvWithTemplateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    InviteFromCsvWithTemplateResponses,
    InviteFromCsvWithTemplateErrors,
    ThrowOnError
  >({
    url: '/items/{id}/invitations/upload-csv-template',
    ...options,
  });
};

/**
 * Invite users from CSV file
 * Invite users from CSV file, given their email, optional name and permission level.
 */
export const inviteFromCsv = <ThrowOnError extends boolean = false>(
  options: Options<InviteFromCsvData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    InviteFromCsvResponses,
    InviteFromCsvErrors,
    ThrowOnError
  >({
    url: '/items/{id}/invitations/upload-csv',
    ...options,
  });
};

/**
 * Create an item membership for the logged in user if there is an Item Login
 * Create an item membership on the item with the given ID for the logged in user.
 * The item needs to be associated with an Item Login.
 */
export const enroll = <ThrowOnError extends boolean = false>(
  options: Options<EnrollData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    EnrollResponses,
    unknown,
    ThrowOnError
  >({
    url: '/items/{itemId}/enroll',
    ...options,
  });
};

/**
 * Get flag types
 * Get available flag types.
 */
export const getFlagTypes = <ThrowOnError extends boolean = false>(
  options?: Options<GetFlagTypesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetFlagTypesResponses,
    GetFlagTypesErrors,
    ThrowOnError
  >({
    url: '/items/flags',
    ...options,
  });
};

/**
 * Flag item
 * Flag item with given type.
 */
export const createItemFlag = <ThrowOnError extends boolean = false>(
  options: Options<CreateItemFlagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateItemFlagResponses,
    CreateItemFlagErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/flags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get own recycled items
 * Get own recycled items.
 */
export const getOwnRecycledItems = <ThrowOnError extends boolean = false>(
  options: Options<GetOwnRecycledItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetOwnRecycledItemsResponses,
    GetOwnRecycledItemsErrors,
    ThrowOnError
  >({
    url: '/items/recycled',
    ...options,
  });
};

/**
 * Recycle many items
 * Recycle many items. This will create as many recycled item data.
 */
export const recycleManyItems = <ThrowOnError extends boolean = false>(
  options: Options<RecycleManyItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RecycleManyItemsResponses,
    RecycleManyItemsErrors,
    ThrowOnError
  >({
    url: '/items/recycle',
    ...options,
  });
};

/**
 * Restore many items
 * Restore many items. This will delete as many recycled item data.
 */
export const restoreManyItems = <ThrowOnError extends boolean = false>(
  options: Options<RestoreManyItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RestoreManyItemsResponses,
    RestoreManyItemsErrors,
    ThrowOnError
  >({
    url: '/items/restore',
    ...options,
  });
};

/**
 * Get latest validation information.
 * Get latest validation information. Returns null if no validation has been performed before.
 */
export const getLatestItemValidationGroup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLatestItemValidationGroupData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetLatestItemValidationGroupResponses,
    GetLatestItemValidationGroupErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/validations/latest',
    ...options,
  });
};

/**
 * Validate item
 * Validate item's tree against many processes, such as nudity detection.
 */
export const validateItem = <ThrowOnError extends boolean = false>(
  options: Options<ValidateItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ValidateItemResponses,
    ValidateItemErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/validate',
    ...options,
  });
};

/**
 * Get likes for current member
 * Get likes for current member. Item property is a packed item.
 */
export const getLikesForCurrentMember = <ThrowOnError extends boolean = false>(
  options?: Options<GetLikesForCurrentMemberData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetLikesForCurrentMemberResponses,
    GetLikesForCurrentMemberErrors,
    ThrowOnError
  >({
    url: '/items/liked',
    ...options,
  });
};

/**
 * Get likes for item
 * Get likes for item.
 */
export const getLikesForItem = <ThrowOnError extends boolean = false>(
  options: Options<GetLikesForItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetLikesForItemResponses,
    GetLikesForItemErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/likes',
    ...options,
  });
};

/**
 * Unlike item
 * Unlike item.
 */
export const deleteItemLike = <ThrowOnError extends boolean = false>(
  options: Options<DeleteItemLikeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteItemLikeResponses,
    DeleteItemLikeErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/like',
    ...options,
  });
};

/**
 * Like item
 * Like item.
 */
export const createItemLike = <ThrowOnError extends boolean = false>(
  options: Options<CreateItemLikeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateItemLikeResponses,
    CreateItemLikeErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/like',
    ...options,
  });
};

/**
 * Clear all mentions for current user
 * Clear all mentions for current user.
 */
export const clearAllMentions = <ThrowOnError extends boolean = false>(
  options?: Options<ClearAllMentionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).delete<
    ClearAllMentionsResponses,
    ClearAllMentionsErrors,
    ThrowOnError
  >({
    url: '/items/mentions',
    ...options,
  });
};

/**
 * Get mentions for current user
 * Get mentions for current user.
 */
export const getOwnMentions = <ThrowOnError extends boolean = false>(
  options?: Options<GetOwnMentionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOwnMentionsResponses,
    GetOwnMentionsErrors,
    ThrowOnError
  >({
    url: '/items/mentions',
    ...options,
  });
};

/**
 * Delete mention
 * Delete mention.
 */
export const deleteMention = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMentionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteMentionResponses,
    DeleteMentionErrors,
    ThrowOnError
  >({
    url: '/items/mentions/{mentionId}',
    ...options,
  });
};

/**
 * Patch mention
 * Patch mention's status.
 */
export const patchMention = <ThrowOnError extends boolean = false>(
  options: Options<PatchMentionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchMentionResponses,
    PatchMentionErrors,
    ThrowOnError
  >({
    url: '/items/mentions/{mentionId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Clear messages of chat
 * Clear messages of chat for given item.
 */
export const clearChatMessage = <ThrowOnError extends boolean = false>(
  options: Options<ClearChatMessageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    ClearChatMessageResponses,
    ClearChatMessageErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/chat',
    ...options,
  });
};

/**
 * Get chat
 * Get chat object for given item.
 */
export const getChat = <ThrowOnError extends boolean = false>(
  options: Options<GetChatData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetChatResponses,
    GetChatErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/chat',
    ...options,
  });
};

/**
 * Save message in chat
 * Save message in chat for given item.
 */
export const createChatMessage = <ThrowOnError extends boolean = false>(
  options: Options<CreateChatMessageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateChatMessageResponses,
    CreateChatMessageErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/chat',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete message in chat
 * Delete message in chat for given item.
 */
export const deleteChatMessage = <ThrowOnError extends boolean = false>(
  options: Options<DeleteChatMessageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteChatMessageResponses,
    DeleteChatMessageErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/chat/{messageId}',
    ...options,
  });
};

/**
 * Edit message in chat
 * Edit message in chat for given item.
 */
export const patchChatMessage = <ThrowOnError extends boolean = false>(
  options: Options<PatchChatMessageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchChatMessageResponses,
    PatchChatMessageErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/chat/{messageId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Save action for item
 * Save action for item with given type and extra.
 */
export const postAction = <ThrowOnError extends boolean = false>(
  options: Options<PostActionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostActionResponses,
    PostActionErrors,
    ThrowOnError
  >({
    url: '/items/{id}/actions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Send request to export actions
 * Send request to export actions for given item. The user receives an email with a download link. The generated export is available for a week, and can be generated only once a day.
 */
export const exportActions = <ThrowOnError extends boolean = false>(
  options: Options<ExportActionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ExportActionsResponses,
    ExportActionsErrors,
    ThrowOnError
  >({
    url: '/items/{id}/actions/export',
    ...options,
  });
};

/**
 * Get actions for item and its descendants by day
 * Get sum of actions count per type generated by users for the given item and its descendants by day.
 */
export const getItemActionsByDay = <ThrowOnError extends boolean = false>(
  options: Options<GetItemActionsByDayData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemActionsByDayResponses,
    GetItemActionsByDayErrors,
    ThrowOnError
  >({
    url: '/items/{id}/actions/actions-by-day',
    ...options,
  });
};

/**
 * Get actions for item and its descendants by hour
 * Get sum of actions count per type generated by users for the given item and its descendants by hour.
 */
export const getItemActionsByHour = <ThrowOnError extends boolean = false>(
  options: Options<GetItemActionsByHourData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemActionsByHourResponses,
    GetItemActionsByHourErrors,
    ThrowOnError
  >({
    url: '/items/{id}/actions/actions-by-hour',
    ...options,
  });
};

/**
 * Get actions for item and its descendants by weekday
 * Get sum of actions count per type generated by users for the given item and its descendants by weekday.
 */
export const getItemActionsByWeekday = <ThrowOnError extends boolean = false>(
  options: Options<GetItemActionsByWeekdayData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemActionsByWeekdayResponses,
    GetItemActionsByWeekdayErrors,
    ThrowOnError
  >({
    url: '/items/{id}/actions/actions-by-weekday',
    ...options,
  });
};

/**
 * Remove a geolocation for an item
 * Remove a geolocation for an item.
 */
export const deleteGeolocation = <ThrowOnError extends boolean = false>(
  options: Options<DeleteGeolocationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteGeolocationResponses,
    DeleteGeolocationErrors,
    ThrowOnError
  >({
    url: '/items/{id}/geolocation',
    ...options,
  });
};

/**
 * Get the geolocation info of the given item
 * Get the geolocation info of the given item, alongside the complete information about the item.
 */
export const getGeolocationByItem = <ThrowOnError extends boolean = false>(
  options: Options<GetGeolocationByItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetGeolocationByItemResponses,
    GetGeolocationByItemErrors,
    ThrowOnError
  >({
    url: '/items/{id}/geolocation',
    ...options,
  });
};

/**
 * Set a geolocation on an item
 * Set a geolocation on an item.
 */
export const putGeolocation = <ThrowOnError extends boolean = false>(
  options: Options<PutGeolocationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    PutGeolocationResponses,
    PutGeolocationErrors,
    ThrowOnError
  >({
    url: '/items/{id}/geolocation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get items within a box defined by geographic coordinates
 * Get accessible items within a box defined by geographic coordinates, within a parent if given.
 */
export const getItemsInBox = <ThrowOnError extends boolean = false>(
  options: Options<GetItemsInBoxData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemsInBoxResponses,
    GetItemsInBoxErrors,
    ThrowOnError
  >({
    url: '/items/geolocation',
    ...options,
  });
};

/**
 * Get address information of given geographic coordinates
 * Get address information of given geographic coordinates. This endpoint is using a third-party API.
 */
export const geolocationReverse = <ThrowOnError extends boolean = false>(
  options: Options<GeolocationReverseData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GeolocationReverseResponses,
    GeolocationReverseErrors,
    ThrowOnError
  >({
    url: '/items/geolocation/reverse',
    ...options,
  });
};

/**
 * Get geographic information from a string
 * Get geographic information from a string. This endpoint is using a third-party API.
 */
export const geolocationSearch = <ThrowOnError extends boolean = false>(
  options: Options<GeolocationSearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GeolocationSearchResponses,
    GeolocationSearchErrors,
    ThrowOnError
  >({
    url: '/items/geolocation/search',
    ...options,
  });
};

/**
 * Get tags for item
 * Get tags for item.
 */
export const getTagsForItem = <ThrowOnError extends boolean = false>(
  options: Options<GetTagsForItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetTagsForItemResponses,
    GetTagsForItemErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/tags',
    ...options,
  });
};

/**
 * Create tag for item
 * Create tag for the item. The tag will be associated with the given item. If the tag does not already exist in the common list of tags, it will be added and other users will see it in their suggestions.
 */
export const createTagForItem = <ThrowOnError extends boolean = false>(
  options: Options<CreateTagForItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateTagForItemResponses,
    CreateTagForItemErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete tag associated with item
 * Delete tag associated with item. It does not throw if the specified tag is not originally associated with the item.
 */
export const deleteTagForItem = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTagForItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteTagForItemResponses,
    DeleteTagForItemErrors,
    ThrowOnError
  >({
    url: '/items/{itemId}/tags/{tagId}',
    ...options,
  });
};

/**
 * Create page
 * Create page and its content.
 */
export const createPage = <ThrowOnError extends boolean = false>(
  options: Options<CreatePageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePageResponses,
    CreatePageErrors,
    ThrowOnError
  >({
    url: '/items/pages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Connect to websockets for a page
 * Connect to websockets for a page and allow collaboration through yjs.
 */
export const pagesWebsockets = <ThrowOnError extends boolean = false>(
  options: Options<PagesWebsocketsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    PagesWebsocketsResponses,
    unknown,
    ThrowOnError
  >({
    url: '/items/pages/{id}/ws/read',
    ...options,
  });
};

/**
 * Connect to websockets for a page
 * Connect to websockets for a page and allow collaboration through yjs.
 */
export const pagesWebsockets2 = <ThrowOnError extends boolean = false>(
  options: Options<PagesWebsockets2Data, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    PagesWebsockets2Responses,
    unknown,
    ThrowOnError
  >({
    url: '/items/pages/{id}/ws',
    ...options,
  });
};

/**
 * Delete many items
 * Delete many items given their ids. This endpoint is asynchronous and a feedback is returned through websockets.
 */
export const deleteManyItems = <ThrowOnError extends boolean = false>(
  options: Options<DeleteManyItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteManyItemsResponses,
    DeleteManyItemsErrors,
    ThrowOnError
  >({
    url: '/items/',
    ...options,
  });
};

/**
 * Create item
 * Create item, whose possible types are folder, app, document, embeddedLink, file, etherpad, h5p and shortcut.
 */
export const createItem = <ThrowOnError extends boolean = false>(
  options?: Options<CreateItemData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    CreateItemResponses,
    CreateItemErrors,
    ThrowOnError
  >({
    url: '/items/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Get item
 * Get item by its id.
 */
export const getItem = <ThrowOnError extends boolean = false>(
  options: Options<GetItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemResponses,
    GetItemErrors,
    ThrowOnError
  >({
    url: '/items/{id}',
    ...options,
  });
};

/**
 * Update item
 * Update item given body.
 */
export const updateItem = <ThrowOnError extends boolean = false>(
  options: Options<UpdateItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateItemResponses,
    UpdateItemErrors,
    ThrowOnError
  >({
    url: '/items/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get accessible items
 * Get items the user has access to
 */
export const getAccessibleItems = <ThrowOnError extends boolean = false>(
  options: Options<GetAccessibleItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAccessibleItemsResponses,
    GetAccessibleItemsErrors,
    ThrowOnError
  >({
    url: '/items/accessible',
    ...options,
  });
};

/**
 * Get children of item
 * Get children of item given its id.
 */
export const getChildren = <ThrowOnError extends boolean = false>(
  options: Options<GetChildrenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetChildrenResponses,
    GetChildrenErrors,
    ThrowOnError
  >({
    url: '/items/{id}/children',
    ...options,
  });
};

/**
 * Get descendant items of item
 * Get descendant items of item given its id.
 */
export const getDescendantItems = <ThrowOnError extends boolean = false>(
  options: Options<GetDescendantItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetDescendantItemsResponses,
    GetDescendantItemsErrors,
    ThrowOnError
  >({
    url: '/items/{id}/descendants',
    ...options,
  });
};

/**
 * Get parent items of item
 * Get parent items of item given its id.
 */
export const getParentItems = <ThrowOnError extends boolean = false>(
  options: Options<GetParentItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetParentItemsResponses,
    GetParentItemsErrors,
    ThrowOnError
  >({
    url: '/items/{id}/parents',
    ...options,
  });
};

/**
 * Reorder item
 * Reorder item within its parent given previous item id.
 */
export const reorderItem = <ThrowOnError extends boolean = false>(
  options: Options<ReorderItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    ReorderItemResponses,
    ReorderItemErrors,
    ThrowOnError
  >({
    url: '/items/{id}/reorder',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Move many items
 * Move many items given their ids to a parent target. This endpoint is asynchronous and a feedback is returned through websockets.
 */
export const moveManyItems = <ThrowOnError extends boolean = false>(
  options: Options<MoveManyItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MoveManyItemsResponses,
    MoveManyItemsErrors,
    ThrowOnError
  >({
    url: '/items/move',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Copy many items
 * Copy many items given their ids in a parent target. This endpoint is asynchronous and a feedback is returned through websockets.
 */
export const copyManyItems = <ThrowOnError extends boolean = false>(
  options: Options<CopyManyItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CopyManyItemsResponses,
    CopyManyItemsErrors,
    ThrowOnError
  >({
    url: '/items/copy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create an item with a thumbnail
 * Create an item with a thumbnail. The data is sent using a form-data.
 */
export const createItemWithThumbnail = <ThrowOnError extends boolean = false>(
  options?: Options<CreateItemWithThumbnailData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    CreateItemWithThumbnailResponses,
    CreateItemWithThumbnailErrors,
    ThrowOnError
  >({
    url: '/items/with-thumbnail',
    ...options,
  });
};

/**
 * Get count for tags
 * Get how many times a tag is associated with items, filtered by string search. It can be filtered by category. Get maximum the 10 most used tags.
 */
export const getCountForTags = <ThrowOnError extends boolean = false>(
  options: Options<GetCountForTagsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCountForTagsResponses,
    GetCountForTagsErrors,
    ThrowOnError
  >({
    url: '/tags/',
    ...options,
  });
};
